// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__CQiwP","loading":"Loading_loading__ZlgUu"};